import CountUp from './CountUp.jsx';

export default function StatsBlock({ items, columns = 4, className = '' }) {
  return (
    <div
      className={`stats-block stats-block--cols-${columns}${className ? ` ${className}` : ''}`}
    >
      {items.map((s) => (
        <div className="stats-block__item" key={s.label}>
          <CountUp value={s.num} className="stats-block__num" />
          <span className="stats-block__label">{s.label}</span>
        </div>
      ))}
    </div>
  );
}
